/*
 * @Author: Chenhw2017 1272617071@qq.com
 * @Date: 2024-07-18 19:38:44
 * @LastEditors: Chenhw2017 1272617071@qq.com
 * @LastEditTime: 2024-08-02 11:27:14
 * @FilePath: /seller.sviptrader.com/src/utils/hotFresh/matcher.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export class Matcher {
	constructor(rules) {
		this.match = this.createMatcher(rules);
	}
	// 生成匹配器
	// 1. 如果仅有api
	// 2. 如果仅有route
	// 3. 如果都有
	createMatcher(rules) {
		this.ruleMap = this.createRuleMap(rules);
		return (api, route) => {
			api = this.adpaterStr(api);
			route = this.adpaterStr(route);
			console.log('api', api, route, this.ruleMap);
			if (this.ruleMap.api[api] || this.ruleMap.route[route]) {
				return true;
			} else if (api && route) {
				return !!this.ruleMap.both[`${api}__${route}`];
			}
		};
	}

	adpaterStr(str) {
		if (str[0] === '/') {
			str = str.slice(1);
		}
		return str;
	}
	createRuleMap(rules) {
		const ruleMap = {
			api: {},
			route: {},
			both: {},
		};
		rules.forEach(rule => {
			let { api, route } = rule;
			api = this.adpaterStr(api);
			route = this.adpaterStr(route);
			if (api && route) {
				ruleMap.both[`${api}__${route}`] = true;
			} else if (api) {
				ruleMap.api[api] = true;
			} else if (route) {
				ruleMap.route[route] = true;
			}
		});
		return ruleMap;
	}
}
